let formatMoney = (n, c, d, t) => {
    if (n === '' || !n) return n;
    var c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;

    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

let formatPhoneNumber = (phoneNumberString) => {
    if (phoneNumberString === '' || !phoneNumberString) return phoneNumberString;
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return phoneNumberString;
}

export default {
    currency: formatMoney,
    phoneNumber: formatPhoneNumber
}



// WEBPACK FOOTER //
// ./src/client/components/Common/formatter.js